<template>
  <v-card rounded="md" outlined>
    <v-card-title :style="`border-top: 3px solid ${colorBackground ? colorBackground : account.color_background}`">
      <v-row justify="center">
        <v-sheet class="overflow-hidden" width="90" rounded="lg" outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="90">
              <v-img :src="account.logo.split(/[?#]/)[0]" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
      </v-row>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col class="pb-0 text-center" cols="12">
          <template v-if="status === 'succeeded'">
            <span class="d-block subtitle-2 font-weight-medium">Recibo de {{account.name}}</span>
            <span class="d-block body-1 font-weight-medium">{{instance.amount | currency(instance.currency)}} {{instance.currency}}</span>
            <span class="d-block subtitle-2 text--primary">Pagado {{instance.payment_date | date}}</span>
          </template>
          <template v-else-if="status === 'failed'">
            <span class="d-block subtitle-2 font-weight-medium">Ha fallado el pago a {{account.name}}</span>
            <span class="d-block body-1 font-weight-medium">{{instance.amount | currency(instance.currency)}} {{instance.currency}}</span>
          </template>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-divider />
    <v-card-text class="py-0 background">
      <v-row>
        <v-col cols="12">
          <span class="d-block text--primary">{{message}}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import ReminderViewMixin from '@/mixins/ReminderViewMixin'
export default {
  props: {
    status: {
      type: String,
      required: false,
      default: () => ('succeeded')
    }
  },
  mixins: [
    ReminderViewMixin
  ]
}
</script>